<script lang="ts">
  import { activeLocationCategoryId, locationCategories } from '$lib/stores';
  import { t } from '$lib/translations';
</script>

<div class="input-wrapper">
  <select
    bind:value={$activeLocationCategoryId}
    class="form-select cat-select peer"
  >
    <option value={undefined}>{ $t('content.allLocations') }</option>
    {#each $locationCategories as category (category.id)}
      <option value={category.id}>{category.name}</option>
    {/each}
  </select>
</div>

<style lang="postcss">
  .input-wrapper {
    @apply w-full my-4;
  }

  .cat-select {
    @apply block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 appearance-none focus:outline-none focus:ring-0 focus:border-gray-200;
  }
</style>
